import { SectionHeaderBar } from '../../common/components/SectionHeaderBar';

export interface BridgeOutstandingProps {}

export const BridgeOutstanding = ({}: BridgeOutstandingProps) => {
    return (
        <>
            <SectionHeaderBar title={'Outstanding'}></SectionHeaderBar>
        </>
    );
};
